'use client';

import Box from '@mui/material/Box';

import { paths, newSearchParams } from 'src/routes/paths';
import { useRouter, useSearchParams } from 'src/routes/hooks';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

import { useAuthContext } from '../../hooks';
import { signOut } from '../../context/firebase';
import { FormCard, FormHead, FormReturnLink } from '../../components';

// ----------------------------------------------------------------------

export function FirebaseVerifyView() {
  const router = useRouter();

  const { user } = useAuthContext();

  const searchParams = useSearchParams();

  const { t, currentLang } = useTranslate();

  const handleSignOut = async () => {
    try {
      if (user?.id) await signOut();
      router.replace(
        `${paths.auth.firebase.signIn}${newSearchParams({ ...Object.fromEntries(searchParams), country: currentLang.countryName })}`
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormCard>
      <FormHead
        icon={<Iconify icon="fluent-color:mail-24" width={80} />}
        title={t('Check your email')}
        slotProps={{ title: { sx: { typography: 'h4' } } }}
      />

      <Box
        sx={{
          gap: 1.5,
          display: 'flex',
          textAlign: 'center',
          typography: 'body2',
          color: 'text.secondary',
          flexDirection: 'column',
        }}
      >
        {t('We have sent a confirmation link to')}
        <Box component="strong" sx={{ color: 'text.primary' }}>
          {user?.email}
        </Box>
        {t('Also check your spam folder')}.
      </Box>

      <FormReturnLink onClick={handleSignOut} />
    </FormCard>
  );
}
